import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/**
 * `eventName` matches the `type` of the actions dispatched by the provider and catalogue functions.
 * A connection test answers `200` even when `succeeded` is `false`: its toast announces "Test
 * effectué", never "réussie" — the pass/fail detail belongs on the card, which is the only place
 * that can also show the failure cause. List-fetch failures (`AI_PROVIDERS_FETCH_FAILED`,
 * `AI_MODELS_FETCH_FAILED`) are deliberately not covered here: `AiEnginesContent` surfaces them
 * inline as its error state, the same choice `OrganizationsNotifications` makes for
 * `ORGANIZATIONS_FETCH_FAILED`. The `MODEL_ASSIGNMENT_*` toasts live in
 * `UI/Pages/AiAssignments/Shared/AiAssignmentsNotifications`, mounted by the three affectation
 * screens: this page does not dispatch those actions.
 */
const AiEnginesNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="AI_PROVIDER_CREATED"
				title="Fournisseur enregistré"
				message="Le fournisseur a bien été enregistré."
			/>
			<SuccessNotification
				eventName="AI_PROVIDER_UPDATED"
				title="Fournisseur mis à jour"
				message="Le fournisseur a bien été mis à jour."
			/>
			<SuccessNotification
				eventName="AI_PROVIDER_DELETED"
				title="Fournisseur supprimé"
				message="Le fournisseur a bien été supprimé."
			/>
			<ErrorNotification
				eventName="AI_PROVIDER_CREATION_FAILED"
				title="Erreur"
				message="Le fournisseur n’a pas pu être enregistré."
			/>
			<ErrorNotification
				eventName="AI_PROVIDER_UPDATE_FAILED"
				title="Erreur"
				message="Le fournisseur n’a pas pu être mis à jour."
			/>
			<ErrorNotification
				eventName="AI_PROVIDER_DELETION_FAILED"
				title="Erreur"
				message="Le fournisseur n’a pas pu être supprimé."
			/>

			<SuccessNotification
				eventName="AI_MODEL_CREATED"
				title="Modèle enregistré"
				message="Le modèle a bien été enregistré."
			/>
			<SuccessNotification
				eventName="AI_MODEL_UPDATED"
				title="Modèle mis à jour"
				message="Le modèle a bien été mis à jour."
			/>
			<SuccessNotification
				eventName="AI_MODEL_DELETED"
				title="Modèle supprimé"
				message="Le modèle a bien été supprimé."
			/>
			<ErrorNotification
				eventName="AI_MODEL_CREATION_FAILED"
				title="Erreur"
				message="Le modèle n’a pas pu être enregistré."
			/>
			<ErrorNotification
				eventName="AI_MODEL_UPDATE_FAILED"
				title="Erreur"
				message="Le modèle n’a pas pu être mis à jour."
			/>
			<ErrorNotification
				eventName="AI_MODEL_DELETION_FAILED"
				title="Erreur"
				message="Le modèle n’a pas pu être supprimé."
			/>
			<ErrorNotification
				eventName="AI_TRANSCRIPTION_DELIVERY_MODES_FETCH_FAILED"
				title="Erreur"
				message="Les modes d’envoi n’ont pas pu être chargés."
			/>

			<SuccessNotification
				eventName="AI_PROVIDER_CONNECTION_TESTED"
				title="Test effectué"
				message="Le test de connexion a été effectué : le résultat s’affiche sur la carte du fournisseur."
			/>
			<SuccessNotification
				eventName="AI_MODEL_CONNECTION_TESTED"
				title="Test effectué"
				message="Le test de connexion a été effectué : le résultat s’affiche sur la carte du modèle."
			/>
		</React.Fragment>
	);
};

export default AiEnginesNotifications;
